import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, confirmed, numeric, min_value, max_value, image, size } from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/pt_BR.json';
import { validate as validateCPF } from 'gerador-validador-cpf'
import { validate as validateCNPJ } from 'cnpj'


const cpf = {
  validate: value => {
    if (!validateCPF(value)) {
      return '{_field_} não é válido'
    }

    return true;
  }
}

const cnpj = {
  validate: value => {
    if (!validateCNPJ(value)) {
      return '{_field_} não é válido'
    }

    return true;
  }
}

const cpf_cnpj = {
  validate: value => {
    let validate = validateCPF(value)

    if( value.length > 14 ) {
      validate = validateCNPJ(value)
    }

    if (!validate) {
      return '{_field_} não é válido'
    }

    return true;
  }
}

const date = {
  validate: value => {
    if (!/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(value)) {
      return '{_field_} não é válida'
    }

    return true;
  }
};

const latitude = {
  validate: value => {
    if (!/^[+-]?(([1-8]?[0-9])(\.[0-9]{1,6})?|90(\.0{1,6})?)$/.test(value)) {
      return '{_field_} não é válida'
    }

    return true;
  }
}

const longitude = {
  validate: value => {
    if (!/^[+-]?((([1-9]?[0-9]|1[0-7][0-9])(\.[0-9]{1,6})?)|180(\.0{1,6})?)$/.test(value)) {
      return '{_field_} não é válida'
    }

    return true;
  }
}

const strong_password = {
  validate: value => {
    if (value.length < 12) {
      return '{_field_} deve ter no mínimo 12 caracteres.'
    }

    if (value.length > 64) {
      return '{_field_} deve ter no máximo 64 caracteres.'
    }

    return true;
  }
}

Object.entries({
  required,
  email,
  confirmed,
  numeric,
  min_value,
  max_value,
  image,
  size,
  date,
  cpf,
  cnpj,
  cpf_cnpj,
  latitude,
  longitude,
  strong_password,
}).forEach(([key, rule]) => {
  extend(key, {
    ...rule,
    message: messages[key]
  })
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
